export type Blip = "open" | "close" | "click" | "success" | "egg";

let ctx: AudioContext | null = null;
let enabled = false;

export function setSoundEnabled(v: boolean) {
    enabled = v;
    if (v) ensure()?.resume?.().catch(() => undefined);
}

function ensure(): AudioContext | null {
    if (!ctx) {
        const AC =
            (window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext })
                .AudioContext ||
            (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
    }
    return ctx;
}

const CONF: Record<Blip, { f0: number; f1: number; dur: number; wave: OscillatorType }> = {
    open: { f0: 500, f1: 700, dur: 0.12, wave: "sine" },
    close: { f0: 520, f1: 300, dur: 0.12, wave: "sine" },
    click: { f0: 760, f1: 760, dur: 0.05, wave: "square" },
    success: { f0: 523, f1: 784, dur: 0.18, wave: "sine" },
    egg: { f0: 392, f1: 988, dur: 0.24, wave: "triangle" },
};

export function play(kind: Blip) {
    if (!enabled) return;
    const a = ensure();
    if (!a) return;
    const t = a.currentTime;
    const c = CONF[kind];
    const osc = a.createOscillator();
    const gain = a.createGain();
    osc.type = c.wave;
    osc.frequency.setValueAtTime(c.f0, t);
    osc.frequency.exponentialRampToValueAtTime(Math.max(c.f1, 1), t + c.dur);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.05, t + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + c.dur + 0.06);
    osc.connect(gain);
    gain.connect(a.destination);
    osc.start(t);
    osc.stop(t + c.dur + 0.1);
}
